import { render } from "./ViewItemComponent.vue?vue&type=template&id=3339c8f6"
import script from "./ViewItemComponent.vue?vue&type=script&lang=js"
export * from "./ViewItemComponent.vue?vue&type=script&lang=js"
script.render = render

export default script